export default "__VITE_ASSET__CnRrI_J8__"